<template>
  <div class="form-wrap">
    <div>
      <a-row>
        <a-col :span="12">
          <h2>发布成果</h2>
        </a-col>
        <a-col :span="12">
          <a-steps>
            <a-step status="process" title="填写资料">
              <a-icon slot="icon" type="user" />
            </a-step>
            <a-step status="wait" title="人工审核">
              <a-icon slot="icon" type="solution" />
            </a-step>
            <a-step status="finish" title="审核成功">
              <a-icon slot="icon" type="smile-o" />
            </a-step>
          </a-steps>
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model
          ref="form"
          :model="model"
          :rules="validatorRules"
          slot="detail"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="成果名称"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="name"
              >
                <a-input
                  v-model="model.name"
                  placeholder="请输入成果名称"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="所在地区"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="areaId"
              >
                <j-area-linkage
                  type="cascader"
                  v-model="model.areaId"
                  placeholder="请输入省市区"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="技术领域"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="technicalField"
              >
                <j-category-select
                  v-model="model.technicalField"
                  pcode="B03"
                  placeholder="请选择技术领域"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" v-if="model.technicalField=='2000847103995158530'" >
              <a-form-model-item
                label="其他技术领域"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="technicalFieldCustom"
              >
                <a-input v-model="model.technicalFieldCustom" placeholder="请填写其他技术领域"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="技术成熟度"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="technicalMaturity"
              >
                <a-input
                  v-model="model.technicalMaturity"
                  placeholder="技术成熟度（例如：产业化、中试、试验阶段等）"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="合作方式"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="cooperateWay"
              >
                <a-input
                  v-model="model.cooperateWay"
                  placeholder="合作方式（例如：技术服务、作价投资、许可使用等）"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="交易价格"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="price"
              >
                <a-input
                  v-model="model.price"
                  placeholder="请输入具体金额或面议"
                  style="width: 100%"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="成果详情"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="detail"
              >
                <j-editor v-model="model.detail" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="知识产权情况"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="knowledgeinfo"
              >
                <j-editor v-model="model.knowledgeinfo" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="应用效果及市场前景"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="applications"
              >
                <j-editor v-model="model.applications" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="技术优势"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="coreTechnologies"
              >
                <j-editor v-model="model.coreTechnologies" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="备注"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="remark"
              >
                <j-editor v-model="model.remark" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="成果关键词"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="tag"
              >
                <!-- <a-input
                  v-model="model.tag"
                  placeholder="请输入成果关键词"
                ></a-input> -->
                <a-select
                  v-model="model.tag"
                  placeholder="填写关键词，多个关键词用英文逗号分隔"
                  mode="tags"
                  style="width: 100%"
                  :token-separators="[',']"
                >
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="成果图片"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="imageUrl"
              >
                <j-image-upload
                  isMultiple
                  v-model="model.imageUrl"
                ></j-image-upload>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="是否公开"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="isOpen"
              >
                <j-dict-select-tag
                  type="radio"
                  v-model="model.isOpen"
                  dictCode="isOpen"
                  placeholder="请选择是否公开"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="所属单位名称"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="projectUnit"
              >
                <a-input
                  v-model="model.projectUnit"
                  placeholder="请输入所属单位名称"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="联系人"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="contactName"
              >
                <a-input
                  v-model="model.contactName"
                  placeholder="请输入联系人"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="联系电话"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="contactPhone"
              >
                <a-input
                  v-model="model.contactPhone"
                  placeholder="请输入联系电话"
                ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item
                label="单位简介"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="unitProfile"
              >
                <a-textarea
                  v-model="model.unitProfile"
                  placeholder="请输入单位简介"
                ></a-textarea>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>

    <div class="btn-wrap">
      <a-button size="large" type="default" @click="cancel">取消</a-button>
      <a-button size="large" type="primary" @click="submitForm">提交</a-button>
    </div>
  </div>
</template>

<script>
import { httpAction, getAction } from "@/api/manage";
import { validateDuplicateValue } from "@/utils/util";
import JDate from "@/components/jeecg/JDate";
import JEditor from "@/components/jeecg/JEditor";
import JSearchSelectTag from "@/components/jeecg/JSearchSelectTag";
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import JCategorySelect from "@comp/jeecg/JCategorySelect";
import JImageUpload from "@/components/jeecg/JImageUpload";
export default {
  name: "TechAchievementForm",
  components: {
    JDate,
    JEditor,
    JAreaLinkage,
    JSearchSelectTag,
    JCategorySelect,
    JImageUpload,
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        name: [{ required: true, message: "请输入成果名称!" }],
        areaId: [{ required: true, message: "请输入所在地区!" }],
        technicalField: [{ required: true, message: "请输入技术领域!" }],
        technicalFieldCustom: [{ required: true, message: "请输入技术领域!" }],
        technicalMaturity: [{ required: true, message: "请输入技术成熟度!" }],
        cooperateWay: [{ required: true, message: "请输入合作方式!" }],
        price: [
          { required: true, message: "请输入交易价格!" }
        ],
        detail: [{ required: true, message: "请输入成果详情!" }],
        knowledgeinfo: [{ required: true, message: "请输入知识产权情况!" }],
        applications: [
          { required: true, message: "请输入应用效果及市场前景!" },
        ],
        coreTechnologies: [{ required: true, message: "请输入技术优势!" }],
        tag: [{ required: true, message: "请输入成果关键词!" }],
        projectUnit: [{ required: true, message: "请输入所属单位名称!" }],
        contactName: [{ required: true, message: "请输入联系人!" }],
        contactPhone: [{ required: true, message: "请输入联系电话!" }],
        isOpen: [
          { required: true, message: "请输入是否公开!" },
        ],
        reviewStatus: [{ required: true, message: "请输入审核状态!" }],
        viewCount: [
          { required: true, message: "请输入浏览量!" },
          { pattern: /^-?\d+$/, message: "请输入整数!" },
        ],
        followCount: [
          { required: true, message: "请输入关注量!" },
          { pattern: /^-?\d+$/, message: "请输入整数!" },
        ],
        delFlag: [
          { required: true, message: "请输入删除状态(0-正常,1-已删除)!" },
        ],
      },
      url: {
        add: "/xjtech/techAchievement/add",
        edit: "/xjtech/techAchievement/edit",
        queryById: "/xjtech/techAchievement/queryById",
      },
    };
  },
  computed: {
    formDisabled() {
      return this.disabled;
    },
  },
  watch: {
    "$route.query.id"(val) {
      if (val) {
        this.loadRecord(val);
      } else {
        this.model = JSON.parse(JSON.stringify(this.modelDefault));
        this.$refs.form && this.$refs.form.resetFields();
      }
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
    const id = this.$route.query.id;
    if (id) {
      this.loadRecord(id);
    }
  },
  methods: {
    cancel() {
      this.$refs.form.resetFields();
    },
    submitForm() {
      let that = this;
      // 触发表单验证
      this.$refs.form.validate((valid, errors) => {
        if (!valid && errors) {
          const firstErrorKey = Object.keys(errors)[0];
          const firstErrorList = firstErrorKey ? errors[firstErrorKey] : [];
          const firstError = Array.isArray(firstErrorList) ? firstErrorList[0] : null;
          const errorMessage =
            (firstError && firstError.message) || "表单校验未通过，请检查输入";
          that.$message.warning(errorMessage);
          return;
        }
        if (valid) {
          that.confirmLoading = true;
          let httpurl = "";
          let method = "";
          if (!this.model.id) {
            httpurl += this.url.add;
            method = "post";
          } else {
            httpurl += this.url.edit;
            method = "put";
          }
          const payload = { ...this.model };
          if (Array.isArray(payload.tag)) {
            payload.tag = payload.tag.join(",");
          }
          httpAction(httpurl, payload, method)
            .then((res) => {
              if (res.success) {
                that.$message.success("提交成功");
                if (this.model.id) {
                  this.$router.push({ path: "/personal" });
                } else {
                  that.$refs.form.resetFields();
                }
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    loadRecord(id) {
      this.confirmLoading = true;
      getAction(this.url.queryById, { id })
        .then((res) => {
          if (res.success) {
            this.model = res.result || {};
            if (this.model.tag && typeof this.model.tag === "string") {
              this.model.tag = this.model.tag.split(",").filter(Boolean);
            }
          } else {
            this.$message.warning(res.message || "加载数据失败");
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>
<style scoped lang="less">
.form-wrap {
  max-width: 900px;
  margin: auto;
}
.btn-wrap {
  text-align: center;
  .ant-btn {
    width: 100px;
    margin: 8px;
  }
}
</style>